import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import {Line} from 'react-chartjs-2';
import Format from '../../utils/Formatter';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

const colors = [
    'rgb(0, 0, 255)',
    'rgb(0, 128, 0)',
    'rgb(255, 0, 0)',
    'rgb(0, 192, 192)',
    'rgb(192, 0, 192)',
    'rgb(192, 192, 0)',
    'rgb(64, 64, 64)',
];

class AcumuladoVendas extends React.Component {

    constructor() {
        super();
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    handleSelectChange(value) {
        this.props.events.onUpdateText('eventosSelecionadosAcumulado', value);
        value.filter(event => !this.props.acumuladoVendas.results[event.value])
            .forEach(event => this.props.events.onListAmountBySlot(event.value, null, null, this.props.token));
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.ACUMULADO_VENDAS)
            return null;

        const selectedEvents = this.props.acumuladoVendas.eventosSelecionadosAcumulado;

        const datasets = selectedEvents
            .filter(event => this.props.acumuladoVendas.results[event.value])
            .map((event, i) => ({
                    label: event.label,
                    borderColor: colors[i],
                    fill: false,
                    data: slotToAcc(this.props.acumuladoVendas.results[event.value]),
                }));
        const labels = datasets.map(ds => ds.data)
            .reduce((max, current) => current.length > max.length ? current : max, [])
            .map(v => v.x);
        const chartData = {
            labels,
            datasets,
        };
        const chartOptions = {
            responsive: true,
            scales: {
                xAxes: [{
                    display: false
                }],
                yAxes: [{
                    ticks: {
                        callback: (value, index, values) => Format.money(value),
                    },
                }],
            },
            tooltips: {
                mode: 'label',
                callbacks: {
                    label: (tooltipItem, data) => Format.money(tooltipItem.yLabel),
                },
            },
        };

        const options = this.props.participants.events
            .map(e => ({label: e.name, value: e.id}));

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Acumulado de vendas (valor)</h2>
                    </div>
                </div>

                <Select multi placeholder="Selecione o(s) evento(s)" value={selectedEvents}
                        options={options} onChange={this.handleSelectChange}/>

                <br/>

                <div className="row">
                    <div className="col-sm-12">
                        {datasets.length > 0 &&
                            <Line data={chartData} options={chartOptions}/>
                        }
                        {datasets.length === 0 &&
                            <h4>Nenhum evento selecionado</h4>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

function slotToAcc(slots) {
    let acc = 0;
    return slots
        .map((r, i) => ({y: acc += r.value, x: i}));
}

export default AcumuladoVendas;



// WEBPACK FOOTER //
// src/views/pages/AcumuladoVendas.jsx